import { Component, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

// Deliberately its own small component rather than an added mode on
// FileUploadDialogComponent — that dialog's importFile() is tied specifically
// to parsing Find & Replace pairs out of a text file (readAsText); this one
// just needs to hand back the raw, unread .zip File for upload. Sharing the
// dialog shell would mean branching find/replace-parsing logic around a
// completely unrelated binary-upload concern instead of reusing anything real.
@Component({
    selector: 'app-import-refinery-dialog',
    templateUrl: './import-refinery-dialog.component.html',
    styleUrls: ['./import-refinery-dialog.component.css'],
    standalone: false
})
export class ImportRefineryDialogComponent {
  selectedFile: File | null = null;
  error: string = '';

  constructor(private dialogRef: MatDialogRef<ImportRefineryDialogComponent>) {}

  @HostListener('document:keydown.escape')
  onEscapePress() {
    this.dialogRef.close();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const name = file.name.toLowerCase();
    if (!name.endsWith('.dtr') && !name.endsWith('.zip')) {
      this.error = 'Please select a .dtr refinery export package.';
      this.selectedFile = null;
      return;
    }

    this.error = '';
    this.selectedFile = file;
  }

  importFile() {
    this.dialogRef.close(this.selectedFile);
  }
}
